import { render, staticRenderFns } from "./GetCreditsModal.vue?vue&type=template&id=0817d663&"
import script from "./GetCreditsModal.vue?vue&type=script&lang=js&"
export * from "./GetCreditsModal.vue?vue&type=script&lang=js&"
import style0 from "./GetCreditsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports